<template>
  <span
      class="inline-flex items-center mr-3 my-2 px-3 py-1 rounded-md text-xs font-medium leading-normal bg-secondary-gray shadow-sm text-primary-black">
    {{text}}
  </span>
</template>

<script>
export default {
  name: "CalculatorSelectedFeature",
  props: ['text']
}
</script>

<style scoped>

</style>
